import { initialize } from 'redux-form';
import { USER_ACCESS_ROLE_FORM } from 'Common/FormEnum';
import {
  CHECKBOX_TYPE_ALLOWREAD,
  CHECKBOX_TYPE_ALLOWWRITE,
  CHECKBOX_TYPE_PREFERENCES,
  accessRowToFieldId,
} from '../helpers/';
import * as types from './types';

export const setPageData = payload => ({
  type: types.USER_ROLE_ACCESS_PAGE_DATA,
  payload: payload,
});

export const setGroups = payload => ({
  type: types.USER_ROLE_ACCESS_SET_GROUPS,
  payload: payload,
});

export const clearGroups = payload => ({
  type: types.USER_ROLE_ACCESS_CLEAR_GROUPS,
});

export const setRoles = payload => ({
  type: types.USER_ROLE_ACCESS_SET_ROLES,
  payload: payload,
});

export const clearRoles = payload => ({
  type: types.USER_ROLE_ACCESS_CLEAR_ROLES,
});

export const setRoleId = payload => ({
  type: types.USER_ROLE_ACCESS_SET_ROLE_ID,
  payload: payload,
});

export const clearRoleId = payload => ({
  type: types.USER_ROLE_ACCESS_CLEAR_ROLE_ID,
});

export const setLoading = payload => ({
  type: types.USER_ROLE_ACCESS_SET_LOADING,
  payload: payload,
});

export const setSaving = payload => ({
  type: types.USER_ROLE_ACCESS_SET_SAVING,
});

export const clearSaving = payload => ({
  type: types.USER_ROLE_ACCESS_CLEAR_SAVING,
});

export const checkAllInGroup = (
  group,
  formValues,
  type = CHECKBOX_TYPE_ALLOWREAD,
  checked = true
) => {
  let values = formValues;

  switch (type) {
    case CHECKBOX_TYPE_ALLOWREAD:
      group.forEach(item => {
        const Id = accessRowToFieldId(item);
        if (values[`AllowRead${Id}`] !== undefined) {
          values[`AllowRead${Id}`] = checked;

          if (checked) {
            values[`AllowWrite${Id}`] = !checked;
          }
        }
      });
      break;
    case CHECKBOX_TYPE_ALLOWWRITE:
    case CHECKBOX_TYPE_PREFERENCES:
      group.forEach(item => {
        const Id = accessRowToFieldId(item);
        if (values[`AllowWrite${Id}`] !== undefined) {
          values[`AllowWrite${Id}`] = checked;

          if (checked) {
            values[`AllowRead${Id}`] = !checked;
          }
        }
      });
      break;
    default:
      values = {};
  }

  return initialize(USER_ACCESS_ROLE_FORM, values);
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/state/actions.js